import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom'
import registerServiceWorker from './registerServiceWorker';
import App from './containers/App';
import 'bootstrap/dist/css/bootstrap.min.css';
import "react-alice-carousel/lib/alice-carousel.css";
import './index.css';

ReactDOM.render(
<BrowserRouter>    
    <App />
</BrowserRouter>
, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js